module.exports = __webpack_public_path__ + "static/p09_pajaroR-8c8c8e6e66cb45c014672dae19d151d6.png";